import { render, staticRenderFns } from "./WithdrawCryptoDetail.html?vue&type=template&id=843cb0cc&scoped=true&"
import script from "./WithdrawCryptoDetail.js?vue&type=script&lang=js&"
export * from "./WithdrawCryptoDetail.js?vue&type=script&lang=js&"
import style0 from "./WithdrawCryptoDetail.scss?vue&type=style&index=0&id=843cb0cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843cb0cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VIcon,VImg,VRow})
